import {
  NotificationActionRowProps,
  TelegramCouplingType,
} from "@shared/features/settings/types";
import Checkbox from "common/Checkbox/Checkbox";
import useMedia from "utils/hooks/useMedia";
import { MOBILE_SEARCH } from "common/constants";
import styled, { css, useTheme } from "styled-components";
import Text from "common/Typography/Text";
import Col from "antd/es/col";
import Row from "antd/es/row";
import { typography } from "@shared/common/Themes/typography";
import { getNewLookTokens, newLookType } from "common/NewLook/tokens.ts";

const NotificationActionRow = ({
  actionTypeItem,
  onCheckboxClick,
  columnSpans,
  telegramToggleOn,
  webToggleOn,
}: NotificationActionRowProps) => {
  const isMobile = useMedia([`(max-width: ${MOBILE_SEARCH})`], [true], false);
  const { isNewLook } = useTheme();
  const hideActionRow =
    actionTypeItem?.is_telegram_active === null &&
    actionTypeItem?.is_web_active === null;

  if (hideActionRow) return null;

  const actionText = (
    <Text
      type="secondary"
      // New look: the body role at every width (the row sets it).
      $size={
        isNewLook
          ? undefined
          : isMobile
          ? typography.fontSizes.S
          : typography.fontSizes.M
      }
    >
      {actionTypeItem?.name}
    </Text>
  );

  return (
    <StyledRow key={actionTypeItem?.type}>
      <Col span={columnSpans?.[0]}>{actionText}</Col>
      <StyledCol span={columnSpans?.[1]}>
        {actionTypeItem?.is_telegram_active !== null && (
          <Checkbox
            checked={actionTypeItem?.is_telegram_active}
            onClick={() =>
              onCheckboxClick(
                actionTypeItem?.type,
                TelegramCouplingType.TELEGRAM_BOT,
                !actionTypeItem?.is_telegram_active
              )
            }
            $useDisabledStyles={!telegramToggleOn}
          />
        )}
      </StyledCol>
      <StyledCol span={columnSpans?.[2]}>
        {actionTypeItem?.is_web_active !== null && (
          <Checkbox
            checked={actionTypeItem?.is_web_active}
            onClick={() =>
              onCheckboxClick(
                actionTypeItem?.type,
                TelegramCouplingType.WEB_OR_APP,
                !actionTypeItem?.is_web_active
              )
            }
            $useDisabledStyles={!webToggleOn}
          />
        )}
      </StyledCol>
    </StyledRow>
  );
};

export default NotificationActionRow;

const StyledRow = styled(Row)`
  align-items: flex-start;
  ${(p) =>
    p.theme.isNewLook &&
    css`
      align-items: center;
      min-height: 40px;
      padding: 6px 20px;
      transition: background-color 120ms;
      /* Under the section name, past its chevron. */
      & > .ant-col:first-child {
        padding-left: 24px;
      }
      &:hover {
        background: ${getNewLookTokens(p.theme).rowHover};
      }
      && .ant-typography {
        ${newLookType.body};
        color: ${getNewLookTokens(p.theme).text};
      }
      /* Phones: a larger tap area around each checkbox. */
      @media (max-width: ${MOBILE_SEARCH}) {
        .ant-checkbox-wrapper {
          padding: 10px;
          margin: -10px;
        }
      }
    `}
`;
const StyledCol = styled(Col)`
  justify-content: flex-end;
  display: flex;
  width: 100%;
  ${(p) =>
    p.theme.isNewLook &&
    css`
      justify-content: center;
    `}
`;
